import {Fragment, useEffect} from 'react'
import classNames from 'classnames'
import _ from '@strings'
import Icon from '@components/Ui/Icon'
import Spacer from '@components/Ui/Spacer'
import Text from '@components/Ui/Text'
import styles from './CheckBoxSpecial.scss'
import {useDispatch, useSelector} from "react-redux";
import {setMarketingState} from "@actions/app";
import {MARKETING_STATE_ACTIVE, MARKETING_STATE_CHECKED} from "@names";
import iconAnim from './icon-animation.gif'
import iconLove from './icon-normal.png'

const CheckBoxSpecial = ({id, options, setValue, value, description}) => {

  const dispatch = useDispatch()
  const marketingState = useSelector((s) => s.data.marketing)

  const toggle = (idx, e) => {
    if (e.target.tagName.toLowerCase() === 'a') {
      return
    }

    const currentValue = value?.[idx]
    let newValue

    if (!currentValue) {
      newValue = options[idx]?.value
    }

    if (!Array.isArray(value)) {
      value = []
    }

    const saveValue = [...value]
    saveValue[idx] = newValue

    setValue(saveValue)

    const isChecked = !value?.[0]

    if(isChecked) {
      dispatch(setMarketingState(MARKETING_STATE_CHECKED))
    } else {
      dispatch(setMarketingState(MARKETING_STATE_ACTIVE))
    }
  }

  const headline = _(`fields.${id}.headline`)

  return (
    <div className={styles.base}>

      {headline &&
        <div>
          <Text type="robo_xmd_bold">{headline}</Text>
          <Spacer vertical scale="0.5"/>
          <div className={styles.icon}>
            {marketingState === MARKETING_STATE_ACTIVE && <div><img src="/app/themes/neuroth-theme/dist/images/applications/icon-animation.gif" /></div>}
            {marketingState === MARKETING_STATE_CHECKED && <div><img src="/app/themes/neuroth-theme/dist/images/applications/icon-normal.png" /></div>}
          </div>
        </div>
      }

      {options.map((option, idx) => (
        <div className={styles.row} key={option.label} onClick={(e) => toggle(idx, e)}>
          <div
            className={classNames(styles.box, {
              [styles.selected]: value?.[idx]
            })}
          >
            {value?.[idx] && <Icon type="check"/>}
          </div>
          <div className={styles.label} dangerouslySetInnerHTML={{__html: option.label}}/>
        </div>
      ))}

      {description &&
        <Fragment>
          <Spacer vertical scale="0.5"/>
          <Text as="div" type="robo_sm" html>{description}</Text>
        </Fragment>
      }

    </div>
  )
}

CheckBoxSpecial.defaultProps = {
  description: '',
  setValue: () => {
  }
}
CheckBoxSpecial.propTypes = {}

export default CheckBoxSpecial
